var _line, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCar02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 112,
    x2: 240,
    y2: 112,
    fill: "none",
    stroke: "#667085",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 24
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M224,168v32a8,8,0,0,1-8,8H188a8,8,0,0,1-8-8V168",
    fill: "none",
    stroke: "#667085",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 24
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M76,168v32a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V168",
    fill: "none",
    stroke: "#667085",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 24
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M224,112,194.11,44.75A8,8,0,0,0,186.8,40H69.2a8,8,0,0,0-7.31,4.75L32,112v56H224Z",
    fill: "none",
    stroke: "#667085",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 24
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCar02);
export default __webpack_public_path__ + "static/media/car02.470e4a4495f39f1524c6d0acc86fcd62.svg";
export { ForwardRef as ReactComponent };